module.exports = __webpack_public_path__ + "img/Office_Group_Laptop_Foreground_Scorecard_Tiles.258e9b9a.jpg";